export default __webpack_public_path__ + "/src/assets/images/climate_blue_notext.svg";